<template>
    <div>
        <TopBackground :titles="'配送地址管理'" :smalls="smalls"/>
        <div class="user_container">
          <table summary="" class="cmsTb1">
            <caption></caption>
            <colgroup>
              <col width="40%;">
              <col width="25%;">
              <col width="25%;">
              <col width="10%;">
            </colgroup>
            <thead>
            <tr>
              <th>收件人</th>
              <th>地址</th>
              <th>手机号码</th>
              <th>删除</th>
            </tr>
            </thead>
            <tbody id="tbodyDataList">
            <tr id="tr_10671" v-for="item in address" :key="item.id">
              <input type="hidden" id="dlvLocIdx_10671" name="dlvLocIdx" class="dlvLocIdx" :value="item.id">
              <td>{{item.name}}</td>
              <td>{{item.address}}</td>
              <td>{{item.mobile}}</td>
              <td>
                <a class="btn_ico_del"  @click="delAddress(item.id)">
                  <img src="../../assets/user/ico_del.png" alt="">
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>
<script>
import request from "@/util/request";
export  default {
  data(){
    return {
      address:[]
    }
  },
  mounted() {
    this.getMyAddress()
  },
  methods:{
    getMyAddress() {
      request.get("address/my").then(res => {
        this.address = res.data
      })
    },
    delAddress(id){
      request.post("address/my/delete",{id:id}).then((res) => {
        if(res.status==200){
         this.$message.success('删除成功')
         this.getMyAddress()
        }else{
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .user_container {
        width: 1200px;
        margin: 39px auto 0;
    }

    .user_container table.cmsTb1 {
      width: 100%;
      border-collapse: collapse;
      text-align: center;
      font-size: 13px;
      line-height: 1.3em;
      word-break: keep-all;
      margin-bottom: 30px;
    }

    .user_container table.cmsTb1 thead th:first-child {
      border-left: none;
    }

    .user_container table.cmsTb1 thead th {
      background: linear-gradient( to bottom, #f6f6f6, #e8e8e8 );
      border-bottom: 1px solid #d3d3d3;
      border-left: 1px solid #d3d3d3;
      padding: 10px 5px 10px;
      font-weight: 400;
    }

    .user_container table.cmsTb1 .btn_ico_del{
      cursor: pointer;
    }


</style>
